<template>
  <div class="examiner">
    <template v-if="sender">
      <VideoSender/>
    </template>
    <template v-else>
      <VideoReceiver
      :remoteClientId="`examiner:${examiner.id}`"
      :token="examiner.p2p_token"/>
    </template>
    <div class="info">
      {{ fullName(examiner) }}
    </div>
  </div>
</template>

<script>
import VideoReceiver from '@/components/VideoReceiver'
import VideoSender from '@/components/VideoSender'

import { fullName } from '@/utils/utils.format'

export default {
  name: 'Examiner',
  props: {
    examiner: Object,
    sender: {
      type: Boolean,
      default: false
    },
  },
  components: {
    VideoReceiver,
    VideoSender,
  },
  methods: {
    fullName
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.examiner {
  width: 200px;
  margin-bottom: 24px;
  margin-right: 16px;
  text-align: center;
}

.info {
  margin-top: 16px;
}

</style>
